document.addEventListener("DOMContentLoaded", function () {
  // FAQ accordion
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".faq-question");
    if (btn) {
      const expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", !expanded);
      btn.nextElementSibling.classList.toggle("open", !expanded);
    }
  });
});